// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"3809e24d","94":"358d0e19","127":"5271c2d2","256":"201fe7e2","279":"2dede097","364":"4dde76c5","376":"fc67d71c","434":"868f8db8","453":"3dc91a15","505":"7b5537de","532":"8e716799","534":"5ba2e184","596":"528f3520","734":"ec1b1e10","803":"5bdda83a","861":"d9098269"}[chunkId] + ".chunk.js";
};